import { onMounted, onBeforeUnmount } from 'vue';
import { registerChangeHandlers, onCellChange } from '../utils/excelUtils';

/**
 * Composable for managing Excel event handlers lifecycle (DEPRECATED)
 *
 * NOTE: This composable is no longer used in child components.
 * Excel handlers are now registered once at the App.vue level after login
 * and cleaned up on logout or app unmount.
 *
 * This function is kept for backward compatibility but should not be used
 * in new code. Use the cleanupExcelHandlers() utility function directly instead.
 *
 * @deprecated Use App-level handler registration instead
 */
export function useExcelEventHandlers() {
    onMounted(() => {
        registerChangeHandlers();
        onCellChange();
    });

    onBeforeUnmount(async () => {
        await cleanupExcelHandlers();
    });
}

/**
 * Cleanup all Excel event handlers
 * Removes cell change handlers from all sheets and sheet-added handlers
 */
export async function cleanupExcelHandlers() {
    await window.Excel.run(async (context) => {
        const sheets = context.workbook.worksheets;

        // Remove cell change handlers from all sheets
        sheets.load("items");
        await context.sync();

        for (const sheet of sheets.items) {
            await sheet.onChanged.removeAll();
        }

        // Remove any global sheet-added handlers
        await sheets.onAdded.removeAll();
        await context.sync();
    });
}
